// extracted by mini-css-extract-plugin
export default {"title":"RedoBySkillSubmit_title__Q96wM","root":"RedoBySkillSubmit_root__F-RGS"};